import { AxiosResponse } from 'axios';
import { HOTEL_AI_URL } from '../../../../config';
import reservationAxios from '../../../../utils/axios/reservation.axios';

const tryToFetchGuestsByRoom = (
    pageNumber: number,
    pageSize: number,
    data?: any,
): Promise<AxiosResponse<any>> => {
    const url = `${HOTEL_AI_URL}/oracle/guests/reservations?page=${pageNumber}&size=${pageSize}`;
    return reservationAxios.put<any>(url, data)
}

const tryToFetchGuestAllReservations = (
    id: string,
    pageNumber: number,
    pageSize: number,
    data?: any,
): Promise<AxiosResponse<any>> => {
    const url = `${HOTEL_AI_URL}/oracle/guests/${id}/reservations/history?page=${pageNumber}&size=${pageSize}`;
    return reservationAxios.get<any>(url, data)
}


const tryToFetchSingleGuest = (id: string): Promise<AxiosResponse<any>> => {
    return reservationAxios.get<any>(`${HOTEL_AI_URL}/oracle/guests/${id}/details`);
};



// guest 2
const tryToFetchGuestsSchedule = (
    pageNumber: number,
    pageSize: number,
    data?: any,
): Promise<AxiosResponse<any>> => {
    const url = `${HOTEL_AI_URL}/guests/scheduled?page=${pageNumber}&size=${pageSize}&search=${data || ''}`;
    return reservationAxios.get<any>(url, data)
}

const tryToFetchGuestAllBooking = (
    id: string,
    pageNumber: number,
    pageSize: number,
    data?: any,
): Promise<AxiosResponse<any>> => {
    const url = `${HOTEL_AI_URL}/bookings/history/${id}?page=${pageNumber}&size=${pageSize}`;
    return reservationAxios.get<any>(url, data)
}


const tryToFetchSingleGuest2 = (id: string): Promise<AxiosResponse<any>> => {
    return reservationAxios.get<any>(`${HOTEL_AI_URL}/guests/${id}/profile`);
};

export const GuestsService = {
    tryToFetchGuestsByRoom,
    tryToFetchSingleGuest,
    tryToFetchGuestAllReservations,
	tryToFetchGuestsSchedule,
	tryToFetchGuestAllBooking,
	tryToFetchSingleGuest2
}